import React from 'react';
import Helmet from 'react-helmet';
import PropTypes from 'prop-types';

const defaultImage = 'https://artdirection.show/assets/favicons/art-direction-share.jpg';

const SEO = ({ title, description, path, image }) => {
  const metaTitle = `The Art Direction Show / ${title}`;
  const metaUrl = `https://artdirection.show${path || ''}`;
  const metaImage = image || defaultImage;
  const metaDescription = description || ' Welcome to the show!';

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{metaTitle}</title>
      <meta name="title" content={metaTitle} />
      <meta name="description" content={metaDescription} />

      {/* Facebook/Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={metaTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:url" content={metaUrl} />
      <meta property="og:image" content={metaImage} />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:title" content={metaTitle} />
      <meta property="twitter:description" content={metaDescription} />
      <meta property="twitter:image" content={metaImage} />
    </Helmet>
  );
};

SEO.defaultProps = {
  title: `The Art Direction Show`,
  description: `Welcome to the show!`,
  image: defaultImage,
};

SEO.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  path: PropTypes.string,
  image: PropTypes.string,
};

export default SEO;
